import { styled } from '@spazious/dollhouse-theme';
import { Flex } from '@spazious/dollhouse-uikit';

export const Grid = styled(Flex)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  grid-gap: var(--spacing-gap);
`;
